<template>
    <div class="default-input"  :class="[errors.length ? 'default-input--error' : '']">
        <label class="default-input__label" v-if="label" :for="id">{{ label }}</label>
        <div class="default-input__input">
            <textarea :type="type" v-model="value" v-mask="maskSettings" :readonly="readOnly" :title="title"
                   :required="required" :placeholder="placeholder" :id="id" :disabled="disabled" :inputmode="inputMode"
                   @click.prevent.stop></textarea>
        </div>
        <div v-if="$slots.action" class="default-input__action">
            <slot name="action"></slot>
        </div>
        <div v-if="errors.length" class="default-input__error">{{ errors[0].$message }}</div>
    </div>
</template>

<script>
export default {
    name: "InputText",
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: [String, Number],
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'text'
        },
        maskSettings: {
            type: [Object, String, null],
            default: ''
        },
        errors: {
            type: [Array, String],
            default: () => []
        },
        addClass: {
            type: String,
            default: '',
        },
        inputMode: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        }
    },
    computed: {
        value: {
            get() {
                return this.modelValue
            },
            set(value) {
                this.$emit('update:modelValue', value)
            }
        },
    }
}
</script>
